/* ============================================================
   Slider des avis.

   Le defilement lui-meme est natif : overflow-x + scroll-snap. Le doigt,
   la molette, le clavier et la barre de defilement fonctionnent donc sans
   une ligne de JS, et sans JS la section reste utilisable. On n'ajoute ici
   que les fleches, les puces et le defilement automatique.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var slice = function (x) { return Array.prototype.slice.call(x); };

  slice(document.querySelectorAll('[data-reviews]')).forEach(function (root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;

    var slides = slice(track.children);
    var dots = slice(root.querySelectorAll('[data-dots] button'));
    if (slides.length < 2) return;

    var held = false, timer = null, anim = null, guard = null, stops = [];
    var delay = parseInt(root.dataset.delay, 10) || 5000;
    var autoplay = root.dataset.autoplay === 'true';
    var DUR = 420;

    /* Les positions d'arret, mesurees sur le rendu reel.

       Une puce par avis serait mensongere : sur grand ecran trois cartes
       sont visibles a la fois, les dernieres ne peuvent jamais venir se
       placer a gauche et leur puce ne s'allumerait jamais. On calcule donc
       la position de defilement de chaque carte, bornee par la fin de la
       piste ; les positions devenues identiques fusionnent. Ce qui reste
       est le nombre reel de pages, quelle que soit la largeur. */
    function measure() {
      var pad = parseFloat(getComputedStyle(track).paddingInlineStart) || 0;
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      stops = [];
      slides.forEach(function (s) {
        var x = Math.min(max, Math.max(0, s.offsetLeft - track.offsetLeft - pad));
        if (stops.length && Math.abs(stops[stops.length - 1] - x) < 2) return;
        stops.push(x);
      });
      dots.forEach(function (d, i) { d.hidden = i >= stops.length; });
      root.classList.toggle('rv-static', stops.length < 2);
      sync();
    }

    function current() {
      var best = 0, gap = Infinity;
      stops.forEach(function (v, i) {
        var d = Math.abs(v - track.scrollLeft);
        if (d < gap) { gap = d; best = i; }
      });
      return best;
    }

    function sync() {
      var i = current();
      dots.forEach(function (d, j) { d.setAttribute('aria-selected', String(j === i)); });
    }

    /* Abandonne le trajet en cours en laissant la piste ou elle en est, et
       remet toujours le calage magnetique : le laisser desactive priverait
       le glissement au doigt de ses reperes. */
    function halt() {
      if (anim) { cancelAnimationFrame(anim); anim = null; }
      if (guard) { clearTimeout(guard); guard = null; }
      track.style.scrollSnapType = '';
    }

    function settle(x) {
      halt();
      track.scrollLeft = x;
      sync();
    }

    /* On anime le defilement a la main plutot que via scrollTo({behavior}) :
       le calage magnetique doit ceder pendant le trajet, sinon le navigateur
       ramene chaque image intermediaire sur la carte la plus proche et le
       mouvement devient saccade.

       Le minuteur de secours n'est pas decoratif : requestAnimationFrame ne
       tourne pas dans un onglet masque ou occulte. Sans lui la piste
       resterait immobilisee en chemin, calage desactive. */
    function slideTo(x) {
      halt();
      var from = track.scrollLeft, dist = x - from;
      if (reduce || Math.abs(dist) < 2) { settle(x); return; }

      track.style.scrollSnapType = 'none';
      var t0 = performance.now();
      guard = setTimeout(function () { settle(x); }, DUR + 400);
      anim = requestAnimationFrame(function step(t) {
        var p = Math.min(1, (t - t0) / DUR);
        if (p >= 1) { settle(x); return; }
        track.scrollLeft = from + dist * (p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2);
        anim = requestAnimationFrame(step);
      });
    }

    function goTo(i) {
      if (!stops.length) return;
      slideTo(stops[(i % stops.length + stops.length) % stops.length]);
    }

    function start() {
      if (reduce || !autoplay || timer || stops.length < 2) return;
      timer = setInterval(function () {
        if (held || document.hidden) return;
        goTo(current() + 1);
      }, delay);
    }
    function stop() { clearInterval(timer); timer = null; }
    function nudge(i) { stop(); goTo(i); start(); }

    dots.forEach(function (d, j) { d.addEventListener('click', function () { nudge(j); }); });
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { nudge(current() - 1); });
    if (next) next.addEventListener('click', function () { nudge(current() + 1); });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });

    ['mouseenter', 'focusin'].forEach(function (e) {
      root.addEventListener(e, function () { held = true; });
    });
    ['mouseleave', 'focusout'].forEach(function (e) {
      root.addEventListener(e, function () { held = false; });
    });

    /* Une prise en main directe interrompt le trajet en cours : rien de plus
       desagreable qu'une piste qui continue de filer sous le doigt. */
    track.addEventListener('wheel', halt, { passive: true });
    root.addEventListener('touchstart', function () { halt(); held = true; }, { passive: true });

    /* Apres un glissement au doigt on rend la main, mais pas immediatement :
       repartir aussitot arracherait la carte que la personne vient d'amener. */
    root.addEventListener('touchend', function () {
      clearTimeout(root._rv);
      root._rv = setTimeout(function () { held = false; }, 2500);
    }, { passive: true });

    var rz = null;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(measure, 180);
    });

    measure();
    start();
  });
})();
